// states_controller.js
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="states"
export default class extends Controller {
  static targets = ["countrySelect", "stateSelect"]

  connect() {
    // Optional: You could trigger fetchStates here if a country
    // is already selected when the page loads (e.g., on an edit form).
    // if (this.countrySelectTarget.value) {
    //   this.fetchStates();
    // }
  }

  fetchStates() {
    const countryId = this.countrySelectTarget.value;
    const stateSelect = this.stateSelectTarget; // Use a shorter variable name inside the function

    // Reset and disable state select immediately
    stateSelect.innerHTML = ""; // Clear existing options first
    // Add the prompt option back immediately after clearing
    const promptOption = document.createElement("option");
    promptOption.value = "";
    promptOption.textContent = "Select a State/Province"; // Match your Rails prompt
    stateSelect.appendChild(promptOption);

    // If no country is selected (e.g., user selected the prompt), stop here.
    if (!countryId) {
        stateSelect.disabled = false; // Keep it enabled but empty (except for prompt)
        return;
    }

    // Show loading indicator (disable while fetching)
    stateSelect.disabled = true;

    fetch(`/states?country_id=${countryId}`, {
      headers: {
        "Accept": "application/json",
        // Include CSRF token if your endpoint requires it for GET, though usually not needed
        // 'X-CSRF-Token': document.querySelector("[name='csrf-token']")?.content
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // Add new options from fetched data (prompt is already there)
        data.forEach(state => {
          const option = document.createElement("option");
          option.value = state.id;
          option.textContent = state.name;
          stateSelect.appendChild(option);
        });

        // Re-enable select
        stateSelect.disabled = false;
      })
      .catch(error => {
        console.error("Error fetching states:", error);
        // Attempt to re-enable the select even if there was an error
        // It will contain only the prompt added earlier.
        stateSelect.disabled = false;
        // Optionally display an error message to the user
      });
  }
}